// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"64c1fef9","189":"64c1fef9","198":"64c1fef9","510":"64c1fef9","567":"64c1fef9","635":"64c1fef9","750":"64c1fef9","873":"64c1fef9","901":"64c1fef9"}[chunkId] + ".chunk.css";
};